import { useEffect, useState } from 'react'
import { Link } from 'react-scroll'
import { NavLink, useNavigate } from 'react-router-dom'
import '../css/navbar.css'
import logo from '../img/logo.png'
import { useLocation } from 'react-router-dom'



const Navbar = () => {


    const [opacity, setOpacity] = useState(false)

    const [wrapp, setWrapp] = useState(false)

    const [menu, setMenu] = useState(false)

      const navigate = useNavigate()
const location = useLocation()

const changeOpacity = () => {
    if (window.scrollY >= 81  && window.innerWidth > 992) {
        setOpacity(true)
    } else {
        setOpacity(false)
    }
}


useEffect(() => {
  changeOpacity()

  window.addEventListener('scroll',changeOpacity)
})

const changeWrapp = () =>{
    
    setWrapp(!wrapp)
}

const changeMenu = () =>{
     if (window.innerWidth <= 992) {
         setMenu(!menu)
     }else if(window.innerWidth > 992 && wrapp === false){
        setWrapp(wrapp)
     }else{
        setWrapp(!wrapp)
     }
   
}
const handleScrollTo = (section) => {
    changeMenu() // cierra el menú siempre que se haga click

    if (location.pathname !== '/') {
      navigate('/') // vuelve al inicio
      setTimeout(() => {
        const element = document.getElementById(section)
        element?.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }, 400)
    } else {
      const element = document.getElementById(section)
      element?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

useEffect(() => {
    if (((!menu && !wrapp) || (menu && !wrapp))){
        setWrapp(wrapp)
}  else  {
    setWrapp(!wrapp)
}

}, [menu])

useEffect(()=>{
    if( window.innerWidth > 992)
        setMenu(!menu)
},[])





 
  return (
    
    <nav className={opacity ? 'active' : 'desactive'}>
        <img className='logo' src={logo} alt='lbdesign'/>
        <div className='menuWrap' onClick={() => changeMenu()}>
            <div className={menu ? 'linea1': 'linea1D'}></div>
            <div className={menu ? 'linea2': 'linea2D'}></div>
            <div className={menu ? 'linea3': 'linea3D'}></div>
        </div>
            <div className={menu ? 'menuActive': 'menuDesactive'}>
                <ul className='menu'   /*      <img className='menuImg' onClick={() => changeMenu()}  src={menuImg}/>*/>
                <li className={location.pathname !== '/' ? 'itemLista1' : 'none'} ><NavLink to='/'className='navLink' onClick={() => changeMenu()}>Inicio</NavLink></li>
                <li className={ location.pathname === '/' ? 'itemLista1' : 'none'}  onClick={() => changeWrapp()}>Servicios<span>▼</span></li>
                <ul className={wrapp && menu ? 'wrappActive' : 'wrappDesactive'}>
                    <li className='itemLista' ><Link to='sitioWeb' onClick={() => changeMenu()} smooth={true} offset={-75} duration={500}>Sitio Web</Link> </li>
                    <li className='itemLista' ><Link to='ecommerce'  onClick={() => changeMenu()}  smooth={true} offset={-75} duration={500}>Ecommerce</Link></li>
                    <li className='itemLista' ><Link to='landingPage'  onClick={() => changeMenu()}  smooth={true} offset={-75} duration={500}>Landing Page</Link></li>
                </ul>
                <li className='itemLista'><Link  to='form' onClick={() => handleScrollTo('form')}  smooth={true} offset={-75} duration={500}>Contacto</Link></li>
                <li className='itemLista'><Link  to='clientes' onClick={() => handleScrollTo('clientes')}  smooth={true} offset={-75} duration={500}>Clientes</Link></li>

                <a className='itemLista' href='https://wa.me/5491126134318' target='blank'><li>Whatsapp</li></a>
                
            </ul>
            </div>
        
    </nav>
  )
}

export default Navbar